import { 
	GET_PROJECT_COMMUNICATIONS_OUTGOING_TYPES, 
	GET_PROJECT_COMMUNICATIONS_OUTGOING_TYPE,
	CREATE_PROJECT_COMMUNICATIONS_OUTGOING_TYPE,
	UPDATE_PROJECT_COMMUNICATIONS_OUTGOING_TYPE,
	DESTROY_PROJECT_COMMUNICATIONS_OUTGOING_TYPE,
} from "./actions"

export function ProjectCommunicationsOutgoingTypesReducer(state = {}, action) {
	switch (action.type) {
		case `${GET_PROJECT_COMMUNICATIONS_OUTGOING_TYPES}_FULFILLED`:{
			return _.mapKeys(action.payload.data, "id");
		}
		case `${GET_PROJECT_COMMUNICATIONS_OUTGOING_TYPE}_FULFILLED`:
		case `${CREATE_PROJECT_COMMUNICATIONS_OUTGOING_TYPE}_FULFILLED`:
		case `${UPDATE_PROJECT_COMMUNICATIONS_OUTGOING_TYPE}_FULFILLED`:{
			let newState = _.clone(state);
			const newItem = action.payload.data;
			const id = _.get(newItem,"id")
			newState[id] = newItem
			return newState;
		}		
		case `${DESTROY_PROJECT_COMMUNICATIONS_OUTGOING_TYPE}_FULFILLED`:{
			let newState = _.clone(state);
			const deletedItem = action.payload.data;
			const id = _.get(deletedItem,"id")
			newState = _.filter(newState,i => i.id != id)
			return newState;
		}
		default:
			return state;
	}
}

// Move this to the reducer page
// import { ProjectCommunicationsOutgoingTypesReducer } from "modules/project/communications/outgoing_types/reducer"

// project_communications_outgoing_types:ProjectCommunicationsOutgoingTypesReducer,
